// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$String from "../../../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getOpenOrderVM(order) {
  return {
          rating: {
            customer_rating: "N/A"
          },
          other: {
            is_penalty_applied: "N/A",
            order_source: order.order_source,
            booking_type: order.booking_type
          }
        };
}

function getEndedOrderVm(order, ended_order) {
  return {
          rating: {
            customer_rating: Belt_Option.mapWithDefault(ended_order.customer_rating, "N/A", (function (v) {
                    return v;
                  }))
          },
          other: {
            is_penalty_applied: "N/A",
            order_source: order.order_source,
            booking_type: order.booking_type
          }
        };
}

function getCancelledOrderVm(order, cancelled_order) {
  return {
          rating: {
            customer_rating: "N/A"
          },
          other: {
            is_penalty_applied: $$String.capitalize_ascii(Pervasives.string_of_bool(cancelled_order.is_penalty_applied)),
            order_source: order.order_source,
            booking_type: order.booking_type
          }
        };
}

function getVm(order) {
  switch (order.TAG | 0) {
    case /* Open */0 :
    case /* Accepted */1 :
    case /* Live */2 :
        return getOpenOrderVM(order._0);
    case /* Ended */3 :
        return getEndedOrderVm(order._0, order._3);
    case /* CancelledCompleted */7 :
        return getCancelledOrderVm(order._0, order._3);
    case /* CancelledEnded */8 :
        return getEndedOrderVm(order._0, order._4);
    default:
      return getCancelledOrderVm(order._0, order._1);
  }
}

export {
  getOpenOrderVM ,
  getEndedOrderVm ,
  getCancelledOrderVm ,
  getVm ,
  
}
/* No side effect */
